module.exports = __webpack_public_path__ + "img/thumbnail_GiantAnteater_f_albino.d7970f94.png";